require('./accessibility.js');

require('./loader.js');

require('./general.js');

require('./header.js');

require('./safari.js');

require('./navigation-desktop.js');

require('./navigation-mobile.js');

require('./navigation-sticky.js');

require('./woo-currency-switcher.js');

require('./switcher.js');

require('./translations.js');

require('./news.js');

require('./installers-form.js');

require('./footer.js');

require('./hubspot.js');

require('./smooth-scroll.js');